<template>
  <div class="picture-page">
    <img class="picture" :src="data.pic" :style="{marginBottom: (data.marginBottom ) / 16 + 'rem', verticalAlign: 'middle'}" @click="handleClick()">

    <!-- 规则定位到页面右上角 -->
		<div v-if="data.rulesLink" class="pos-rule" :style="{ color: data.rulesColor }" @click="handleClickRule">规则</div>
  </div>
</template>

<script>
import { sensorsBuriedPoint, getUrlParam } from '../common/util';
import clientUtil from '../common/clientUtil';
import createMessage from './Toast/index.js'
export default {
  name: "Picture",
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  methods: {
    handleClick() {
      console.log('图片点击事件', this.data);
      let btnEventType = this.data.btnEventStatus;
      // 进行打点
      if(this.data.pointName) sensorsBuriedPoint(this.data.pointName, {
        LocationPage: this.data.LocationPage,
        BannerType: this.data.BannerType,
        BannerRank: this.data.BannerRank,
        userkey: getUrlParam("userKey") || "",
        Url: this.data.linkH5 || this.data.linkClient
      });
      switch (btnEventType) {
        // 跳转链接
        case 'jumpLinkH5': {
          window.location.href = this.data.linkH5;
          break;
        }
        case 'jumpLinkClient': {
          clientUtil.openNewWebPage({
            pageUrl: this.data.linkClient,
          })
          break;
        }
        case "jumpWxPage": { // 跳转到微信
          // eslint-disable-next-line
          const Toast = createMessage;
          eval(this.data.btnExtraEvent);
          setTimeout(() => {
            window.location.href = "weixin://";
          }, 2000);
          break;
        }
        case "jumpMiniPro": { // 跳转微信小程序
          const data = {
            path: "pages/splash/index",
          };
          clientUtil.getHeaders((headers) => {
            data["YX-IMEI"] = headers["YX-IMEI"];
          });
          // eslint-disable-next-line
          post('/api/v1/getMiniProgramtUrl', data).then(res => {
            if (res.data) {
              const { openlink } = res.data;
              setTimeout(() => {
                window.location.href = openlink
              }, 2000)
              // eslint-disable-next-line
              const Toast = createMessage;
              eval(this.data.btnExtraEvent);
            } else {
              createMessage({ text: "打开失败，请稍后重试" })
            }
          })
          break;
        }
        case "InMiniProJump": { // 小程序内部跳转事件
          const ua = navigator.userAgent.toLowerCase();
          const isWeiXin = ua.indexOf("micromessenger") > -1;
          if (!isWeiXin) {
            createMessage({
              text: this.data.miniErrorToast || '请在微信小程序打开当前页面',
              timeout: 2000
            })
            return;
          }
          // eslint-disable-next-line
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              // eslint-disable-next-line
              wx.miniProgram.navigateTo({
                url: this.data.linkMiniPath
              })
            } else {
              createMessage({
                text: this.data.miniErrorToast || '请在微信小程序打开当前页面',
                timeout: 2000
              })
            }
          })
          break;
        }
        case 'btnEvent': {
          if (this.data.btnEvent === '复制并打开支付宝') {
            this.copy('证件中心');
            // 判断在小程序中，点击进行toast提示
            if (getUrlParam('isApplet') === '1') {
              createMessage({
                text: '请手动打开支付宝APP查询',
                timeout: 2000
              });
              return;
            }
            clientUtil.getHeaders((headers) => {
              if(headers['YX-Version'] < 721) {
                // 版本过低 不支持跳转支付宝
                createMessage({
                  text: '当前版本过低，请升级后再试',
                  timeout: 2000
                });
                return;
              }
              // 跳转客户端页面
              clientUtil.openNewWebPage({
                pageUrl: 'hfqdl://others/app/open?url=alipays%3A%2F%2Fplatformapi%2Fstartapp&errMsg=%E5%B0%9A%E6%9C%AA%E5%AE%89%E8%A3%85%E6%94%AF%E4%BB%98%E5%AE%9D',
              })
            })
            return;
          }
          break;
        }
      }
    },
    // 展示规则弹窗
		handleClickRule() {
			window.open(this.data.rulesLink);
		},
    copy(text) {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", text); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
    }
  }
}
</script>

<style lang="less" scoped>
.picture-page {
  position: relative;
}
.picture {
  display: block;
  width: 100%;
  height: auto;
}
.pos-rule {
	position: absolute;
	top: 20px;
	right: 0;
	width: 54px;
	height: 23px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 11px 0 0 11px;
	line-height: 23px;
	font-size: 11px;
	font-family: PingFang SC;
  text-align: center;
}
</style>
